import { Component } from 'react';
import isEqual from 'lodash-es/isEqual';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import classNames from 'classnames/bind';

import {
  filterByAllDate,
  filterByAllCategory,
  filterBySource,
} from '../../../../../actions/filingsFilters.actions';

import fewFilingsIcon from '../../../../../assets/few-stories-icon.svg';
import withComponentName from '../../../../../decorators/withComponentName';

import StorageSvc from '../../../../../services/StorageSvc';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class NoContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTimeFilter: true,
      showAllCategory: true,
      showAllSource: true,
      showApplyAll: true,
    };
    autoBind(this);
  }

  componentDidMount() {
    const { storyFilters, hasSourceAccess } = this.props;
    const {
      filing_categories_all: categoryAll, filing_sources_all: sourceAll,
      filings_time_filter: timeFilterType,
    } = storyFilters;

    this.setState({
      showTimeFilter: timeFilterType !== 'lifetime',
      showAllCategory: !categoryAll,
      showAllSource: !sourceAll && hasSourceAccess,
    }, () => {
      this.setApplyAll();
    });
  }

  componentDidUpdate(prevProps) {
    const { storyFilters } = this.props;
    if (!isEqual(storyFilters, prevProps.storyFilters)) {
      this.setStateValues();
    }
  }

  setStateValues() {
    const { storyFilters, hasSourceAccess } = this.props;
    const {
      filing_categories_all: categoryAll, filing_sources_all: sourceAll,
      filings_time_filter: timeFilterType,
    } = storyFilters;

    this.setState({
      showTimeFilter: timeFilterType !== 'lifetime',
      showAllCategory: !categoryAll,
      showAllSource: !sourceAll && hasSourceAccess,
    }, () => {
      this.setApplyAll();
    });
  }

  setApplyAll() {
    const { state } = this;
    const stateKey = ['showTimeFilter', 'showAllCategory', 'showAllSource'];
    const trueKey = stateKey.filter((key) => state[key]);
    this.setState({
      showApplyAll: trueKey.length >= 2,
    });
  }

  handleFilterByAllDate() {
    const { token, filterByAllDate: propsFilterByAllDate, storyFilters } = this.props;
    const { filing_period_start_datetime: sDate, filing_period_end_datetime: eDate } = storyFilters;
    propsFilterByAllDate({
      filings_time_filter: 'lifetime',
      filing_period_start_datetime: sDate,
      filing_period_end_datetime: eDate,
    }, token);
    if (!token) {
      StorageSvc.setItem('FilingsTimeFilter', JSON.stringify({
        start_date: sDate, end_date: eDate, filings_time_filter: 'lifetime',
      }));
    }
  }

  handleFilterBySource() {
    const {
      token, filterBySource: propsFilterBySource, handleFilterReset,
    } = this.props;
    propsFilterBySource({
      filing_source_ids: [],
      filing_sources_all: true,
    }, token);
    handleFilterReset('isSourceReset', true);
  }

  handleFilterByAllCategory() {
    const {
      token, filterByAllCategory: propsFilterByAllCategory, handleFilterReset,
    } = this.props;
    propsFilterByAllCategory({
      filing_categories_all: true,
      filing_types_all: true,
    }, token);
    handleFilterReset('isCategoryReset', true);
  }

  handleFilterByApplyAll() {
    const { onReset } = this.props;
    onReset();
  }

  render() {
    const { hasSourceAccess } = this.props;
    const {
      showTimeFilter, showAllCategory, showAllSource, showApplyAll,
    } = this.state;

    const hasFilters = showTimeFilter || showAllCategory || showAllSource || showApplyAll;

    return (
      <div className={Styles.no_content_row}>
        <div className={Styles.no_content_img}>
          <img src={fewFilingsIcon} alt="filings icon" height="42" width="42" />
        </div>
        <div className={Styles.body_content}>
          <div className={Styles.title}>
            {
              hasFilters
                ? 'No content was found that matches your criteria'
                : (
                  <>
                    <div>No filings have been found.</div>
                    <div>
                      None may exist or the source may not yet be integrated.
                      Sources are added regularly.
                    </div>
                  </>
                )
            }
          </div>
          <div className={cx('filters', { has_filters: hasFilters })}>
            {
              hasFilters
                ? <div className={Styles.filings_label}>Try these filter settings:</div>
                : null
            }
            {
              showTimeFilter && (
                <div
                  className={Styles.filings_filter}
                  onClick={this.handleFilterByAllDate}
                >
                  Longer Period
                </div>
              )
            }
            {
              hasSourceAccess && showAllSource
                ? (
                  <div
                    className={Styles.filings_filter}
                    onClick={this.handleFilterBySource}
                  >
                    All Sources
                  </div>
                )
                : null
            }
            {
              showAllCategory && (
                <div
                  className={Styles.filings_filter}
                  onClick={this.handleFilterByAllCategory}
                >
                  All Categories & Types
                </div>
              )
            }
            {
              showApplyAll && (
                <div
                  className={Styles.filings_filter}
                  onClick={this.handleFilterByApplyAll}
                >
                  APPLY ALL
                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ watchlistReducer, storyFilters }) => ({
  storyFilters,
  token: watchlistReducer.userToken,
  isExpandAll: storyFilters.expand_filings,
});

const mapDispatchToProps = {
  filterByAllDate,
  filterByAllCategory,
  filterBySource,
};

export default withComponentName(
  connect(mapStateToProps, mapDispatchToProps)(NoContent),
);
